import { getContextualRequest, normalizeUPApiError } from '../../../../modules/utils/index.js';
export async function fetchResubscribeProduct(client) {
    try {
        const req = await getContextualRequest(client);
        const res = await req.get(`${client.context.api.host}/subscriptions/products/resubscribe`);
        return res.body;
    }
    catch (error) {
        throw normalizeUPApiError(error);
    }
}
